<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import ResetView from '@/components/HeaderButtons/ResetView.vue';
import ExportButtonDropdown from '@/components/HeaderButtons/ExportDropdown.vue';
import PreviewButton from '@/components/HeaderButtons/PreviewButton.vue';
import Logo from '@/assets/images/logo.svg?url';

const appVersion = import.meta.env.PACKAGE_VERSION as string;
const route = useRoute();

const isInPreviewMode = computed(() => route.path === '/preview');
</script>

<template>
  <div class="w-full border-b flex flex-row space-between items-center">
    <div class="mr-auto ml-1 flex flex-row items-end">
      <img :src="Logo" alt="3D Tour Builder" class="h-[36px] py-px">
      <div class="flex flex-row justify-end">
        <p class="text-xs ml-0.5 leading-none">
          v{{ appVersion }}
        </p>
      </div>
    </div>
    <div class="flex flex-row justify-center items-center mr-1">
      <ResetView v-if="isInPreviewMode === false" class="mr-1" />
      <PreviewButton class="mr-1" />
      <ExportButtonDropdown v-if="isInPreviewMode === false" />
    </div>
  </div>
</template>
